import {connect} from 'react-redux'
import ReportPanel from '../components/report-panel'
import * as reportActions from '../store/report/actions'

export default connect((state) => state.report, reportActions)(ReportPanel)



// WEBPACK FOOTER //
// ./src/containers/report-panel-container.js